export default __webpack_public_path__ + "static/media/p_b_white_updated.f3b8a8f6.png";